export default __webpack_public_path__ + "static/media/ApplicationDenied.a93e3cce.svg";